import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AfterOnboardAPI from "../../services/AfterOnboardAPI";
import { handlehideContextualLoader, handleShowContextualLoader } from "../../utils/contextualLoaderTrigger";
import { useDispatch, useSelector } from "react-redux";
import { setStepperDisable } from "../../redux/slices/userSlice";
import Swal from "sweetalert2";
import { clevertap_selfie_verification_success } from "../../lib/clevertap-events";

export default function Hyperverge() {
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const { selfieHypervergeResult } = new AfterOnboardAPI();

  const { accountId } = useSelector((state) => state.user);

  const startHypervergeResult = async () => {
    try {
      handleShowContextualLoader("Verifying your Selfie...");
      const response = await selfieHypervergeResult(accountId);
      const status = response?.data?.status;

      await new Promise((res) => setTimeout(res, 3000));

      if (status == "auto_approved") {
        clevertap_selfie_verification_success();
        navigate("/term-condition");
      } else if (status == "auto_declined") {
        navigate("/home");
      } else if (status == "user_cancelled") {
        navigate("/selfie-verification");
      } else {
        navigate("/dashboard");
      }
    } catch (error) {
      console.error("Error starting Hyperverge result:", error);
      Swal.fire({
        icon: "error",
        text: "Something went wrong",
      });
      await new Promise((res) => setTimeout(res, 3000));
      navigate("/dashboard");
    } finally {
      handlehideContextualLoader();
      dispatch(setStepperDisable(false));
    }
  };

  useEffect(() => {
    startHypervergeResult();
  }, []);

  return null;
}
